import { Component, OnInit } from '@angular/core';
import { ServicioAnticipoService } from 'src/app/services/servicio-anticipo.service';
import { Anticipo, EntidadEmpresarial, AfiliadoAdmision } from '../../services/servicio-anticipo.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertModel, ETipoAlert } from '../shared/alert/alert.component';
import { ActivatedRoute } from '@angular/router';
import { ExcelService } from 'src/app/services/utils/excel.service';

@Component({
  selector: 'app-reporte-anticipo',
  templateUrl: './reporte-anticipo.component.html',
  styleUrls: ['./reporte-anticipo.component.css']
})
export class ReporteAnticipoComponent implements OnInit {

  loading: boolean = true;
  errorAlert: AlertModel = new AlertModel;
  lista: boolean;

  afiliado: AfiliadoAdmision;
  anticipos: Anticipo[] = [];
  anticipoActual: Anticipo;
  entidadEmpresarial: EntidadEmpresarial = new EntidadEmpresarial;
  fechaActual = new Date
  filtro: any;

  constructor(private activatedRoute: ActivatedRoute,
    private anticipoService: ServicioAnticipoService,
    private servicioExcel: ExcelService) {
    this.activatedRoute.params.subscribe(params => {
      this.filtro = {
        codigoBaseDatos: params['codigoBaseDatos'],
        uncoSede: params['uncoSede'],
        uncoLogin: params['uncoLogin'],
        consecutivoAdmision: params['consecutivoAdmision'],
        uncoAnticipo: params['uncoAnticipo']
      }
      this.lista = this.filtro.uncoAnticipo === undefined;
    });
  }

  ngOnInit() {
    this.getEntidadEmpresarial();
  }

  errorRequest(mensaje: string) {
    this.loading = false
    this.errorAlert = {
      mensaje,
      tipo: ETipoAlert.danger,
      visible: true
    }
  }

  async getEntidadEmpresarial() {
    const response = await this.anticipoService.getEntidadEmpresarial(this.filtro.codigoBaseDatos, this.filtro.uncoSede);
    if (response != null) {
      response.subscribe((data: any) => {
        if (data && Array.isArray(data) && data.length > 0) {
          this.entidadEmpresarial = data[0]
          this.getInformacionAfiliado()
        }
      }, (err: HttpErrorResponse) => {
        this.errorRequest('Error grave al obtener la entidad empresarial, reporte caso al administrador')
        console.log('Error entidad Empresarial', err);
      });
    }
  }

  async getInformacionAfiliado() {
    const response = await this.anticipoService.getInformacionAfiliado(this.filtro.codigoBaseDatos, {
      consecutivo: this.filtro.consecutivoAdmision,
      uncoLogin: this.filtro.uncoLogin,
      uncoSede: this.filtro.uncoSede
    });
    if (response != null) {
      response.subscribe((data: AfiliadoAdmision) => {
        this.afiliado = data;
        this.getAnticipos()
      }, (err: HttpErrorResponse) => {
        console.log(err);
        this.errorRequest('Error grave al obtener información del afiliado, reporte caso al administrador');
      });
    }
  }

  async getAnticipos() {
    let response = await this.anticipoService.getAnticipos(this.filtro.codigoBaseDatos, this.afiliado.uncoAdmision);
    response.subscribe((data: Anticipo[]) => {
      if (this.lista) {
        this.anticipos = data;
      } else {
        this.anticipoActual = data.find(anticipo => (anticipo.unco == this.filtro.uncoAnticipo))
      }

      this.loading = false;
    }, err => {
      this.errorRequest('Error grave al obtener la lista de anticipos, reporte caso al administrador')
    });
  }

  onImprimir() {
    let printContents: any, popupWin: any;
    printContents = document.getElementById('comprobante-informe-print').innerHTML;

    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto,menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes');
    popupWin.document.open();

    popupWin.document.write(`
        <html>
          <head>
            <title> Standard Health | Reportes </title>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css"
            integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
            <style>
              /* Tamaños fuentes */
  
              .font-title {
                  font-size: 150px;
              }
  
              .font-subtitle {
                  font-size: 30px;
              }
  
              .font-normal {
                  font-size: 16px;
              }
              .container {
                font-family: Arial, Helvetica, sans-serif;
              }
              
              div.info-user span {
                float: left;
                width: 140px;
              }
              
              div.info-header span {
                float: left;
                width: 140px;
              }
              
              table.info-combrobantes {
                width: 100%;
                
              }
              
              table.info-combrobantes th {
                text-align: center;
                width: 25%;
                border: 1px solid lightgray;
              }
              
              .anticipoActual td {
                border: 1px solid lightgray;
              }
            </style>
          </head>
          <body onload="window.print();window.close()">
            ${ printContents}
            <br/>
            <hr/>
            <br/>
            ${ printContents}
          </body>
        </html>`
    );
    popupWin.document.close();
  }

  generarCSV() {
    let headers = "Fecha,Forma de Pago,Entidad,Valor";
    let data: string;

    let objectReport = (anticipo: Anticipo) => ({
      fecha: anticipo.fechaPago,
      formaPago: anticipo.formaPago,
      entidad: anticipo.usuario,
      valor: anticipo.valor
    });

    if (this.lista) {
      let rows = this.anticipos.map((anticipo: Anticipo) => {
        return Object.values(objectReport(anticipo)).join(',')
      });
      data = rows.join('\r\n');
    } else {
      data = Object.values(objectReport(this.anticipoActual)).join(',')
    }
    let csvArray = `${headers}\r\n${data}`;
    this.servicioExcel.exportAsCSVFile(csvArray, 'ReporteAnticipo');
  }
}